import type { Variant } from '../types.ts';
import { bounce } from './bounce.ts';
import { classic } from './classic.ts';
import { comeback } from './comeback.ts';
import { cooldown } from './cooldown.ts';
import { duel } from './duel.ts';
import { explode } from './explode.ts';
import { flip } from './flip.ts';
import { goose } from './goose.ts';
import { grey } from './grey.ts';
import { heir } from './heir.ts';
import { hp } from './hp.ts';
import { lava } from './lava.ts';
import { levelup } from './levelup.ts';
import { masquerade } from './masquerade.ts';
import { portal } from './portal.ts';
import { snail } from './snail.ts';
import { storm } from './storm.ts';
import { traitor } from './traitor.ts';
import { wildcard } from './wildcard.ts';
import { wrap } from './wrap.ts';
import { zombie } from './zombie.ts';

export * from './bounce.ts';
export { classic } from './classic.ts';
export * from './comeback.ts';
export * from './cooldown.ts';
export * from './duel.ts';
export * from './explode.ts';
export * from './flip.ts';
export * from './goose.ts';
export * from './grey.ts';
export * from './heir.ts';
export * from './hp.ts';
export * from './lava.ts';
export * from './levelup.ts';
export * from './masquerade.ts';
export * from './portal.ts';
export * from './snail.ts';
export * from './storm.ts';
export * from './traitor.ts';
export * from './wildcard.ts';
export * from './wrap.ts';
export * from './zombie.ts';

/** Every variant, by id. The campaign schedule (packages/shared) decides when each is released. */
export const VARIANTS: Record<string, Variant> = {
  [classic.id]: classic,
  [snail.id]: snail,
  [explode.id]: explode,
  [goose.id]: goose,
  [bounce.id]: bounce,
  [storm.id]: storm,
  [cooldown.id]: cooldown,
  [hp.id]: hp,
  [lava.id]: lava,
  [levelup.id]: levelup,
  [wrap.id]: wrap,
  [zombie.id]: zombie,
  [portal.id]: portal,
  [traitor.id]: traitor,
  [flip.id]: flip,
  [duel.id]: duel,
  [wildcard.id]: wildcard,
  [masquerade.id]: masquerade,
  [grey.id]: grey,
  [comeback.id]: comeback,
  [heir.id]: heir,
};

export function getVariant(id: string): Variant | null {
  return Object.hasOwn(VARIANTS, id) ? VARIANTS[id] : null;
}
